export const MAX_ORDERABLE_QUANTITY = 99999;

export const QUANTITY_INPUT_PATTERN = new RegExp(`^$|^[1-9]\\d{0,${String(MAX_ORDERABLE_QUANTITY).length - 1}}$`);

const WHOLE_NUMBER = /^\d+$/;

export function isOrderableQuantity(quantity: string): boolean {
    return WHOLE_NUMBER.test(quantity) && Number(quantity) >= 1 && Number(quantity) <= MAX_ORDERABLE_QUANTITY;
}

export function formatMaxOrderableQuantity(locale: string): string {
    return MAX_ORDERABLE_QUANTITY.toLocaleString(locale);
}
